<template>
  <div class="min-h-screen flex items-center justify-center bg-cazalec-white">
    <div class="max-w-md w-full p-8 bg-white rounded-lg shadow-xl border border-gray-100">
      <div>

      </div>
      <div class="text-center mb-10 ">
        <img class="flex justify-center m-auto" src="/images/icons/logo_c.webp" alt="Cazalec_logo">
        <p class="text-gray-500 mt-2">Connectez-vous à votre compte</p>
      </div>

      <form @submit.prevent="handleLogin" class="space-y-6">
        <div>
          <label class="block text-sm font-medium text-gray-700">E-mail</label>
          <input
              v-model="email"
              type="email"
              required
              class="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-cazalec-blue focus:border-cazalec-blue"
              placeholder="admin@cazalec.com"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700">Mot de passe</label>
          <input
              v-model="password"
              type="password"
              required
              class="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-cazalec-blue focus:border-cazalec-blue"
              placeholder="••••••••"
          />
        </div>

        <button
            type="submit"
            :disabled="loading"
            class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-cazalec-blue hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cazalec-blue font-bold transition-colors"
        >
          {{ loading ? 'Chargement...' : 'Se connecter' }}
        </button>

        <div v-if="error" class="text-red-500 text-sm text-center mt-4">
          {{ error }}
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {useRouter} from 'vue-router';
import { jwtDecode } from "jwt-decode"; // تأكد من تثبيتها عبر npm install jwt-decode
// استيراد العميل المخصص الذي أنشأناه بدلاً من axios الخام
import apiClient from '@/api/index.js';
const email = ref('');
const password = ref('');
const error = ref('');
const loading = ref(false);
const router = useRouter();

const handleLogin = async () => {
  loading.value = true;
  error.value = ''; // تصحيح: كانت error.ref سابقاً

  try {
    // 1. إرسال الطلب عبر العميل المخصص (الرابط يكمل الـ Base URL الموجود في .env)
    const response = await apiClient.post('/login_check', {
      username: email.value,
      password: password.value
    });

    // 2. تخزين التوكن الأساسي وتوكن التجديد (Refresh Token)
    // ملاحظة: تأكد أن الباك إند يعيد حقلاً باسم refresh_token
    const token = response.data.token;
    localStorage.setItem('token', token);

    if (response.data.refresh_token) {
      localStorage.setItem('refresh_token', response.data.refresh_token);
    }

    // 1. فك تشفير التوكن لاستخراج الأدوار (Roles)
    const decoded = jwtDecode(token);
    const roles = decoded.roles || []; // Symfony يضع الأدوار عادةً في حقل roles

    // 2. التوجيه بناءً على أعلى صلاحية
    if (roles.includes('ROLE_ADMIN')|| decoded.roles.includes('ROLE_SUPERVISOR')) {
      router.push('/admin/dashboard');
    } else if (roles.includes('ROLE_WORKER')) {
      router.push('/worker/dashboard');
    } else {
      // في حال وجود مستخدم بدون أدوار محددة وجهه لمكان افتراضي أو اظهر خطأ
      error.value = "Accès non autorisé : rôle insuffisant.";
    }

  } catch (err) {
    // معالجة الخطأ بناءً على الرد القادم من السيرفر
    if (err.response && err.response.status === 401) {
      error.value = "Identifiants invalides (adresse e-mail ou mot de passe incorrect)";
    } else {
      error.value = "Erreur de connexion au serveur";
    }
  } finally {
    loading.value = false;
  }
};
</script>